<template>
  <a-modal
    v-model="show"
    :width="700"
    title="员工如何使用电子优惠券"
  >
    <div>
      <div class="fs-20 mb-10">
        什么是电子运费券？
      </div>
      电子运费券用于寄件时抵扣运费使用，企业可通过运营活动发放获得，使用规则：<br>

      1、电子运费券只能由公司主账号领取获得，子账号无法领取和获得<br>

      2、公司领取的运费抵扣券，公司主账号、子账号均可共享使用<br>

      3、不同的优惠券的使用范围及期限不一样，以具体说明为准<br>

      4、系统检测到有运费券时，系统自动匹配可用运费券抵扣使用<br>

      5、电子运费券仅支持“公司预存”时使用，不支持其他结算模式时使用
      <div class="fs-20 mb-10 mt-10">

        员工如何使用？
      </div>

      1、公司分配的子账号登录企业寄件系统<br>

      2、确保公司账户有可用的电子运费券<br>

      3、下单并使用“公司预存”结算模式时，由系统自动抵扣可用的运费券
    </div>

    <div slot="footer">

      <a-button type="primary" @click="show = false">好的，我知道了</a-button>
    </div>
  </a-modal>
</template>
<script>
export default {
  props: {
    viz: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      show: this.viz
    }
  },
  watch: {
    show(n) {
      this.$emit('update:viz', n)
    },
    viz(n) {
      this.show = n
    }
  }
}
</script>
<style lang="scss" scoped>
.c-tips{
    position: relative;
    .close{
        position: absolute;
        top: 20px;
        right: 20px;
        cursor: pointer;
    }
}
</style>
